const NoMatch = () => {
  return (
    <div className="mx-auto max-w-7xl p-3 lg:px-7 font-bold text-xl text-black dark:text-white">
      Sorry No Match Found 😢
    </div>
  );
};

export default NoMatch;
